/**
 * HotspotStat3 — Fix-Agent hotspot-detail (P1)
 *
 * 3 freistehende Stat-Kacheln (Rewards 24h/30d + Uptime 30d), SPEC
 * hotspot-detail.html #stat3: separate .card.card-pad-Kacheln unterhalb des
 * Hero, KEIN gemeinsamer Rahmen/Farbverlauf (der lebte vorher faelschlich im
 * hero-mesh-Wrapper von HotspotHeroBar, siehe dortiger Kommentar).
 */
import { useTranslation } from 'react-i18next'
import type { HotspotDetail } from './useHotspotDetail'
import { fmt } from '../../lib/fmt'

type Props = {
  hotspot: HotspotDetail
}

export function HotspotStat3({ hotspot }: Props) {
  const { t } = useTranslation('hotspots')
  // Issue #88: vierte Kachel nur wenn network_share vorhanden ist (Mobile-
  // Hotspots liefern null — Phase 1 deckt nur IoT ab).
  const share = hotspot.network_share ?? null
  return (
    <div
      className={`htdt-stat3${share ? ' htdt-stat3--4' : ''}`}
      role="list"
      aria-label={t('heroBar.statLabel')}
    >
      <div className="card card-pad" role="listitem">
        <div className="htdt-stat3-label">{t('heroBar.stat24h')}</div>
        <div className="num-md" style={{ margin: '4px 0' }}>
          {hotspot.hnt_24h != null ? `${hotspot.hnt_24h.toFixed(3)} HNT` : '—'}
        </div>
      </div>
      <div className="card card-pad" role="listitem">
        <div className="htdt-stat3-label">{t('heroBar.stat30d')}</div>
        <div className="num-md" style={{ margin: '4px 0' }}>
          {hotspot.hnt_30d != null ? `${hotspot.hnt_30d.toFixed(3)} HNT` : '—'}
        </div>
      </div>
      <div className="card card-pad" role="listitem">
        <div className="htdt-stat3-label">{t('heroBar.statUptime')}</div>
        <div className="num-md" style={{ margin: '4px 0' }}>
          {hotspot.online_pct != null ? `${hotspot.online_pct.toFixed(1)}%` : '—'}
        </div>
      </div>
      {share && (
        <div className="card card-pad" role="listitem" data-testid="hotspot-network-share-tile">
          <div className="htdt-stat3-label">{t('heroBar.statNetworkShare')}</div>
          <div className="num-md" style={{ margin: '4px 0', overflowWrap: 'anywhere' }}>
            {/* Korrektheits-Review #88: share_percent ist backend-seitig NIE
                null, own_hotspots_rewarded ist das robuste Signal fuer "kein
                eigener Reward in dieser Epoche" (siehe NetworkShareFooter). */}
            {share.own_hotspots_rewarded > 0
              ? `${fmt(share.share_percent ?? 0, 2)}%`
              : t('heroBar.networkShareNoOwnRewards')}
          </div>
          {share.own_hotspots_rewarded > 0 && share.benchmark_ratio != null && (
            <div className="muted" style={{ fontSize: 11, overflowWrap: 'anywhere' }}>
              {t('heroBar.networkShareBenchmark', { ratio: fmt(share.benchmark_ratio, 2) })}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
